import React, { useMemo, useState } from 'react';
import axios from 'axios';
import useDetailFetch from '../../../../hooks/useDetailFetch';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';

import { useParams, useNavigate } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';

const SingleContactDetails = () => {
    const { contactId } = useParams();
    const navigate = useNavigate();
    const { showToast } = React.useContext(ToastContext);
    const decodedId = contactId ? atob(contactId) : contactId;
    const id = decodedId.replace(/\D/g, '');
    const [showDelete, setShowDelete] = useState(false);

    const url = id ? `${API_DOMAIN}${API_ROUTES.contact}${id}/` : null;
    const { data: contactDetails, loading } = useDetailFetch(url);

    const columns = useMemo(() => {
      if (!contactDetails) return null;
      const excludedColumns = ['id', 'updated_at', 'created_at'];
      return Object.keys(contactDetails).filter(column => !excludedColumns.includes(column)).map((column) => ({
        label: column.charAt(0).toUpperCase() + column.slice(1),
        field: column,
      }));
    }, [contactDetails]);

    const handleDelete = async () => {
      try {
        await axios.delete(`${API_DOMAIN}${API_ROUTES.contact}${id}/`, { headers });
        showToast('Contact deleted successfully', 'success');
        navigate('/contact/list');
      } catch (error) {
        console.error('Error deleting contact:', error);
        showToast('Error deleting contact', 'error');
      }
    };

    return (
      <div>
        <SingleItemDetailTemplate
          details={contactDetails}
          columns={columns}
          loading={loading}
          entityName="Contact"
          listPath="/contact/list"
          editPath={`/contact/input/${btoa(id)}`}
          onDelete={() => setShowDelete(true)}
        />
        <ConfirmModal
          isOpen={showDelete}
          title="Delete Contact"
          message="Are you sure you want to delete this contact? This action cannot be undone."
          onConfirm={handleDelete}
          onCancel={() => setShowDelete(false)}
          confirmText="Delete"
          cancelText="Cancel"
        />
      </div>
    );
  };

  export default SingleContactDetails;
